export default {
  FORM_FACTOR_REQUEST(state) {
    state.chartData.deviceCountByFormFactor.error = false;
    state.chartData.deviceCountByFormFactor.errorMessage = "";
    state.chartData.deviceCountByFormFactor.originalError = null;
    state.chartData.deviceCountByFormFactor.loading = true;
  },

  FORM_FACTOR_FAILURE(state, err) {
    state.chartData.deviceCountByFormFactor.loading = false;
    state.chartData.deviceCountByFormFactor.error = true;
    state.chartData.deviceCountByFormFactor.errorMessage = "Can't fetch from database";
    state.chartData.deviceCountByFormFactor.originalError = err.exception;
  },

  FORM_FACTOR_SUCCESS(state, {response}) {
    state.chartData.deviceCountByFormFactor.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.deviceCountByFormFactor.data = response.data.data;
    }
    state.chartData.deviceCountByFormFactor.lastUpdatedAt = new Date();
  },

  MODEL_COUNT_REQUEST(state) {
    state.chartData.deviceCountByModel.error = false;
    state.chartData.deviceCountByModel.errorMessage = "";
    state.chartData.deviceCountByModel.originalError = null;
    state.chartData.deviceCountByModel.loading = true;
  },

  MODEL_COUNT_FAILURE(state, err) {
    state.chartData.deviceCountByModel.loading = false;
    state.chartData.deviceCountByModel.error = true;
    state.chartData.deviceCountByModel.errorMessage = "Can't fetch from database";
    state.chartData.deviceCountByModel.originalError = err.exception;
  },

  MODEL_COUNT_SUCCESS(state, {response}) {
    state.chartData.deviceCountByModel.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.deviceCountByModel.data = response.data.data;
    }
    state.chartData.deviceCountByModel.lastUpdatedAt = new Date();
  },

  WARRANTY_REQUEST(state) {
    state.chartData.deviceCountByWarrantyExpiration.error = false;
    state.chartData.deviceCountByWarrantyExpiration.errorMessage = "";
    state.chartData.deviceCountByWarrantyExpiration.originalError = null;
    state.chartData.deviceCountByWarrantyExpiration.loading = true;
  },

  WARRANTY_FAILURE(state, err) {
    state.chartData.deviceCountByWarrantyExpiration.loading = false;
    state.chartData.deviceCountByWarrantyExpiration.error = true;
    state.chartData.deviceCountByWarrantyExpiration.errorMessage = "Can't fetch from database";
    state.chartData.deviceCountByWarrantyExpiration.originalError = err.exception;
  },

  WARRANTY_SUCCESS(state, {response}) {
    state.chartData.deviceCountByWarrantyExpiration.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.deviceCountByWarrantyExpiration.data = response.data.data;
    }
    state.chartData.deviceCountByWarrantyExpiration.lastUpdatedAt = new Date();
  },

  AGE_REQUEST(state) {
    state.chartData.devicesByAge.error = false;
    state.chartData.devicesByAge.errorMessage = "";
    state.chartData.devicesByAge.originalError = null;
    state.chartData.devicesByAge.loading = true;
  },

  AGE_FAILURE(state, err) {
    state.chartData.devicesByAge.loading = false;
    state.chartData.devicesByAge.error = true;
    state.chartData.devicesByAge.errorMessage = "Can't fetch from database";
    state.chartData.devicesByAge.originalError = err.exception;
  },

  AGE_SUCCESS(state, {response}) {
    state.chartData.devicesByAge.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.devicesByAge.data = response.data.data;
    }
    state.chartData.devicesByAge.lastUpdatedAt = new Date();
  },

  UTILISATION_REQUEST(state) {
    state.chartData.devicesByUtilisation.error = false;
    state.chartData.devicesByUtilisation.errorMessage = "";
    state.chartData.devicesByUtilisation.originalError = null;
    state.chartData.devicesByUtilisation.loading = true;
  },

  UTILISATION_FAILURE(state, err) {
    state.chartData.devicesByUtilisation.loading = false;
    state.chartData.devicesByUtilisation.error = true;
    state.chartData.devicesByUtilisation.errorMessage = "Can't fetch from database";
    state.chartData.devicesByUtilisation.originalError = err.exception;
  },

  UTILISATION_SUCCESS(state, {response}) {
    state.chartData.devicesByUtilisation.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.devicesByUtilisation.data = response.data.data;
    }
    state.chartData.devicesByUtilisation.lastUpdatedAt = new Date();
  },

  DEVICES_REQUEST(state) {
    state.devices.loading = true;
    state.devices.error = null;
  },

  DEVICES_SUCCESS(state, {response}) {
    state.devices.loading = false;
    state.devices.error = null;
    if (response && response.data && response.data.data) {
      state.devices.data = response.data.data;
      state.devices.pagination.totalItems = response.data.data.length;
    }
    state.devices.lastUpdatedAt = new Date();

  },
  DEVICES_FAILURE(state, err) {
    state.devices.loading = false;
    state.devices.error = err;
  },

  DEVICE_COUNT_REQUEST(state) {
    state.deviceCount.loading = true;
    state.deviceCount.error = null;
  },

  DEVICE_COUNT_SUCCESS(state, {response}) {
    state.deviceCount.loading = false;
    state.deviceCount.error = null;
    if (response && response.data && response.data.data) {
      state.deviceCount.data = response.data.data;
    }
  },
  DEVICE_COUNT_FAILURE(state, err) {
    state.deviceCount.loading = false;
    state.deviceCount.error = err;
  },

  setPagination(state, pagination) {
    state.devices.pagination = pagination;
  },

  setFilter(state, filter) {
    switch (filter['field']) {
      case 'formfactor':
        state.filters.formfactor = filter.value;
        break;
      case 'age':
        state.filters.age = filter.value;
        break;
      case 'utilisation':
        state.filters.utilisation = filter.value;
        break;
      case 'warranty':
        state.filters.warranty = filter.value;
        break;
      case 'buildNumber':
        state.filters.buildNumber = filter.value;
        break;
      case 'operatingSystem':
        state.filters.operatingSystem = filter.value;
        break;
      case 'model':
        state.filters.model = filter.value;
        break;
      default:
        break;
    }
  },

  clearFilter(state, field) {
    switch (field) {
      case 'formfactor':
        state.filters.formfactor = '';
        break;
      case 'age':
        state.filters.age = '';
        break;
      case 'utilisation':
        state.filters.utilisation = '';
        break;
      case 'warranty':
        state.filters.warranty = '';
        break;
      case 'buildNumber':
        state.filters.buildNumber = '';
        break;
      case 'operatingSystem':
        state.filters.operatingSystem = '';
        break;
      case 'model':
        state.filters.model = '';
        break;
      default:
        break;
    }
  },

  clearAllFilters(state) {
    state.filters = {
      formfactor: '',
      model: '',
      age: '',
      utilisation: '',
      warranty: '',
      buildNumber: '',
      operatingSystem: '',
    };
  },

  HOURLY_BANDWIDTH_USAGE_FETCH_REQUEST(state) {
    state.chartData.hourlyBandwidthUsage.loading = true;
    state.chartData.hourlyBandwidthUsage.error = false;
    state.chartData.hourlyBandwidthUsage.errorMessage = "";
    state.chartData.hourlyBandwidthUsage.originalError = null;
  },

  HOURLY_BANDWIDTH_USAGE_FETCH_SUCCESS(state, {department, nonDepartment}) {
    state.chartData.hourlyBandwidthUsage.loading = false;
    state.chartData.hourlyBandwidthUsage.error = false;
    state.chartData.hourlyBandwidthUsage.errorMessage = null;
    if (department && department.data && department.data.data) {
      state.chartData.hourlyBandwidthUsage.department = department.data.data;
    }
    if (nonDepartment && nonDepartment.data && nonDepartment.data.data) {
      state.chartData.hourlyBandwidthUsage.nonDepartment = nonDepartment.data.data;
    }
  },

  HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_REQUEST(state) {
    state.chartData.hourlyBandwidthUsage.loading = true;
    state.chartData.hourlyBandwidthUsage.error = false;
    state.chartData.hourlyBandwidthUsage.errorMessage = "";
    state.chartData.hourlyBandwidthUsage.originalError = null;
  },

  HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_SUCCESS(state, data) {
    state.chartData.hourlyBandwidthUsage.loading = false;
  },

  HOURLY_BANDWIDTH_USAGE_BY_DEPARTMENT_FAILURE(state, err) {
    state.chartData.hourlyBandwidthUsage.loading = false;
    state.chartData.hourlyBandwidthUsage.error = true;
    state.chartData.hourlyBandwidthUsage.errorMessage = "Error getting HOURLY BANDWIDTH USAGE data";
    state.chartData.hourlyBandwidthUsage.originalError = err;
  },

  HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_REQUEST(state) {
    state.chartData.hourlyBandwidthUsage.loading = true;
    state.chartData.hourlyBandwidthUsage.error = false;
    state.chartData.hourlyBandwidthUsage.errorMessage = "";
    state.chartData.hourlyBandwidthUsage.originalError = null;
  },

  HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_SUCCESS(state, data) {
    state.chartData.hourlyBandwidthUsage.loading = false;
  },

  HOURLY_BANDWIDTH_USAGE_BY_NON_DEPARTMENT_FAILURE(state, err) {
    state.chartData.hourlyBandwidthUsage.loading = false;
    state.chartData.hourlyBandwidthUsage.error = true;
    state.chartData.hourlyBandwidthUsage.errorMessage = "Error getting HOURLY BANDWIDTH USAGE data";
    state.chartData.hourlyBandwidthUsage.originalError = err;
  },

  NUMBER_OF_HITS_REQUEST(state) {
    state.chartData.numberOfHits.error = false;
    state.chartData.numberOfHits.errorMessage = "";
    state.chartData.numberOfHits.originalError = null;
    state.chartData.numberOfHits.loading = true;
  },

  NUMBER_OF_HITS_FAILURE(state, err) {
    state.chartData.numberOfHits.loading = false;
    state.chartData.numberOfHits.error = true;
    state.chartData.numberOfHits.errorMessage = "Can't fetch from database";
    state.chartData.numberOfHits.originalError = err.exception;
  },

  NUMBER_OF_HITS_SUCCESS(state, {response}) {
    state.chartData.numberOfHits.loading = false;
    state.chartData.numberOfHits.data = response.data.data;
    state.chartData.numberOfHits.lastUpdatedAt = new Date();
  },

  BANDWIDTH_USAGE_REQUEST(state) {
    state.chartData.bandwidthUsage.error = false;
    state.chartData.bandwidthUsage.errorMessage = "";
    state.chartData.bandwidthUsage.originalError = null;
    state.chartData.bandwidthUsage.loading = true;
  },

  BANDWIDTH_USAGE_FAILURE(state, err) {
    state.chartData.bandwidthUsage.loading = false;
    state.chartData.bandwidthUsage.error = true;
    state.chartData.bandwidthUsage.errorMessage = "Can't fetch from database";
    state.chartData.bandwidthUsage.originalError = err.exception;
  },

  BANDWIDTH_USAGE_SUCCESS(state, {response}) {
    state.chartData.bandwidthUsage.loading = false;
    state.chartData.bandwidthUsage.data = response.data.data;
    state.chartData.bandwidthUsage.lastUpdatedAt = new Date();
  },

  BUILD_NUMBER_COUNT_REQUEST(state) {
    state.chartData.deviceBuildNumber.error = false;
    state.chartData.deviceBuildNumber.errorMessage = "";
    state.chartData.deviceBuildNumber.originalError = null;
    state.chartData.deviceBuildNumber.loading = true;
  },

  BUILD_NUMBER_COUNT_FAILURE(state, err) {
    state.chartData.deviceBuildNumber.loading = false;
    state.chartData.deviceBuildNumber.error = true;
    state.chartData.deviceBuildNumber.errorMessage = "Can't fetch from database";
    state.chartData.deviceBuildNumber.originalError = err.exception;
  },

  BUILD_NUMBER_COUNT_SUCCESS(state, {response}) {
    state.chartData.deviceBuildNumber.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.deviceBuildNumber.data = response.data.data;
    }
    state.chartData.deviceBuildNumber.lastUpdatedAt = new Date();
  },

  OPERATING_SYSTEM_COUNT_REQUEST(state) {
    state.chartData.deviceOperatingSystem.error = false;
    state.chartData.deviceOperatingSystem.errorMessage = "";
    state.chartData.deviceOperatingSystem.originalError = null;
    state.chartData.deviceOperatingSystem.loading = true;
  },

  OPERATING_SYSTEM_COUNT_FAILURE(state, err) {
    state.chartData.deviceOperatingSystem.loading = false;
    state.chartData.deviceOperatingSystem.error = true;
    state.chartData.deviceOperatingSystem.errorMessage = "Can't fetch from database";
    state.chartData.deviceOperatingSystem.originalError = err.exception;
  },

  OPERATING_SYSTEM_COUNT_SUCCESS(state, {response}) {
    state.chartData.deviceOperatingSystem.loading = false;
    if (response && response.data && response.data.data) {
      state.chartData.deviceOperatingSystem.data = response.data.data;
    }
    state.chartData.deviceOperatingSystem.lastUpdatedAt = new Date();
  },
}
